import { ListService } from '@abp/ng.core';
import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { finalize, tap } from 'rxjs/operators';
import { GetAssetEventsInput } from '../../../../proxy/asset-events/models';
import { AssetWithNavigationPropertiesDto } from '../../../../proxy/assets/models';
import { EquipmentDto } from '../../../../proxy/equipments/models';
import { AssetService } from '../../../../proxy/assets/asset.service';
//import { stringify } from '@angular/compiler/src/util';

@Component({
  selector: 'app-search-asset-modal',
  templateUrl: './search-asset-modal.component.html',
  styleUrls: []
})
export class SearchAssetModalComponent implements OnInit {
  filters = {} as GetAssetEventsInput;

  form: FormGroup;

  isModalBusy = false;

  isModalOpen = false;

  selected?: AssetWithNavigationPropertiesDto;

  equipment: EquipmentDto;

  @Output() showNewAssetModal = new EventEmitter<boolean>();

  constructor(
    public readonly list: ListService,
    public readonly service: AssetService,
    private confirmation: ConfirmationService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {}

  setEquipment(equipment: EquipmentDto){
    this.equipment = equipment;
  }

  buildForm() {
    this.form = this.fb.group({
      assetId: [null],
      equipmentId: [this.equipment.id],
    });
  }

  hideForm() {
    this.isModalOpen = false;
    this.form.reset();
  }

  showForm() {
    if(this.equipment){
      this.buildForm();
      this.isModalOpen = true;
    }
  }

  submitForm() {
    if (this.form.invalid) return;

    const request = this.service.updateEquipment(this.form.value);

    this.isModalBusy = true;

    request
      .pipe(
        finalize(() => (this.isModalBusy = false)),
        tap(() => this.hideForm()),
      )
      .subscribe(this.list.get);
  }

  assetChangeEvent(){
    if(this.form.controls.assetId.value != null && this.form.controls.assetId.value != ""){
      this.service.getWithNavigationProperties(this.form.controls.assetId.value).subscribe(response => {
        if(response.equipment.id != null && response.equipment.id != this.equipment.id){
          this.confirmation.warn(
            'Inventory::UpdateAssetEquipmentConfirmationMessage',
            'Inventory::AreYouSure',
            { messageLocalizationParams: [] }
          ).subscribe(confirmationOption =>{
            if(confirmationOption == Confirmation.Status.reject){
              this.buildForm();
            }
          });
        }
      });
    }
  }

  create(){
    this.hideForm();
    this.showNewAssetModal.emit(true);
  }

}
